export interface IContentProps {
  isCateringOrder: boolean;
  upsellEnabled?: boolean;
  mobileCartUpsellLocation?: string;
  addOnEnabled?: boolean;
}

export enum MobileAreaOptions {
  DETAILS = 'details',
  CART = 'cart',
  PAYMENT = 'payment',
  UPSELL = 'upsell',
  ADDONS = 'addons',
}

export enum WebAreaOptions {
  DETAILS = 'details cart',
  PAYMENT = 'payment cart',
  UPSELL = 'upsell cart',
  ADDONS = 'addons cart',
  UNNAMED = '. payment',
}
